// extracted by mini-css-extract-plugin
export default {"header":"Header_header__8Xs6a","logoSection":"Header_logoSection__3upC0"};